module.exports = __webpack_public_path__ + "img/Maskgroup.3710e84b.png";